import angular from "angular";
import panel from "../services";

function profileVisitor (panel) {

    return {
        restrict: 'E',
        scope: {
            pc: '='
        },
        link: function(scope) {
          $(document).ready(() => {
            let elem = new Foundation.Tabs($("#user-tabs"), {});
          })
        },
        template: require('./templates/profile/visitor.html')
    }
};

export default angular.module('directives.profileVisitor', [panel]).directive('profileVisitor', profileVisitor).name;



// WEBPACK FOOTER //
// ./src/app/directives/profileVisitor.js